import { memo } from 'react';
import type { ReactNode } from 'react';
import { Tooltip } from '@library';
import type { LoggedInProductCustomerPrice } from '../../../../product/types';
import PreorderProductPriceBreakdown from './PreorderProductPriceBreakdown';
import styles from './PriceBreakdown.module.css';

const PriceBreakdown = ({
    children,
    customerPrice,
}: {
    children: ReactNode;
    customerPrice: LoggedInProductCustomerPrice;
}) => {
    return (
        <Tooltip
            content={
                <PreorderProductPriceBreakdown productPrice={customerPrice} />
            }
            showArrow
            theme={styles.theme}
        >
            <div> {children}</div>
        </Tooltip>
    );
};
export default memo(PriceBreakdown);
